// Jeden GLOBÁLNY modal verejného profilu pre celú appku. Kdekoľvek sa otvára cez hook —
// žiadne lokálne kópie stavu po komponentoch:
//
//   const { open } = useProfileModal();
//   open(uid);   // vždy rovnaký element; Šťuchnúť + „⋮" akcie sú zabudované v ProfileModal
//                // a riadia sa údajmi profilu (rel/is_me).
//
// Stav (ktoré uid je otvorené) aj konkrétne handlery akcií (`actions`) vlastní appka (Main),
// pretože akcie potrebujú navigáciu appky (chat, výzva, zdieľaný kalendár). Provider ich len
// rozdá cez kontext a vykreslí jediný <ProfileModal>. Samotné telo/vzhľad = ./ProfileModal.
import { createContext, useContext, useMemo } from "react";
import { ProfileModal } from "./ProfileModal";

const Ctx = createContext(null);

export function ProfileModalProvider({ uid, onOpen, onClose, actions, highlightReaction = null, children }) {
  const value = useMemo(() => ({ open: onOpen, close: onClose }), [onOpen, onClose]);
  return (
    <Ctx.Provider value={value}>
      {children}
      {uid != null && <ProfileModal uid={uid} actions={actions} onClose={onClose} highlightReaction={highlightReaction} />}
    </Ctx.Provider>
  );
}

export function useProfileModal() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useProfileModal must be used within ProfileModalProvider");
  return v;
}
